import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
// import { SectionTitle } from "../../components/styledComponent";
import styles from "./style.module.scss";

const JOTFORM_IFRAME_ID = "JotFormIFrame-261165351811249";
const JOTFORM_SCRIPT_ID = "jotform-embed-handler-script";

const MerchantApplication = () => {
  useEffect(() => {
    if (window.jotformEmbedHandler) {
      window.jotformEmbedHandler(
        `iframe[id='${JOTFORM_IFRAME_ID}']`,
        "https://form.jotform.com/"
      );
      return;
    }

    const existingScript = document.getElementById(JOTFORM_SCRIPT_ID);
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = JOTFORM_SCRIPT_ID;
    script.src = "https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js";
    script.async = true;
    script.onload = () => {
      if (window.jotformEmbedHandler) {
        window.jotformEmbedHandler(
          `iframe[id='${JOTFORM_IFRAME_ID}']`,
          "https://form.jotform.com/"
        );
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div className={styles.merchantApplicationPage}>
      <Container>
        {/* <SectionTitle $textAlign="center">Merchant Application</SectionTitle> */}
        <div className={styles.formWrapper}>
          <iframe
            id={JOTFORM_IFRAME_ID}
            title="Canco Merchant Account Application"
            onLoad={() => window.parent.scrollTo(0, 0)}
            allowTransparency="true"
            allow="geolocation; microphone; camera; fullscreen; payment"
            src="https://form.jotform.com/261165351811249"
            frameBorder="0"
            style={{ minWidth: "100%", maxWidth: "100%", height: "539px", border: "none" }}
            scrolling="no"
          />
        </div>
      </Container>
    </div>
  );
};

export default MerchantApplication;
